var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.heroImage)?_c('img',{staticClass:"pet-photo",attrs:{"src":_vm.heroImage.thumbnails.small,"width":"100","alt":_vm.pet.name}}):_c('img',{staticClass:"pet-photo",attrs:{"src":require("../../assets/Images/DogProfile_Blue_300.svg"),"width":"100","alt":"DefaultPetImage"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }